import React from 'react'
import { connect } from 'react-redux'
import {
  onFetchWebSurvey,
  onSetSubmissionSurvey,
  onResetWebSurvey,
  onResetCurrentSurvey,
  onResetSubmissionSurvey
} from '../../WebSurveys/modules/WebSurvey'
import ActivitiesPage from '../components/ActivitiesPage'
import Loader from 'components/D3Loader'
import { sendEvent } from '../modules/Instruments'
import { isBlockConsent } from '../../Consent/utils/consentUtils'
import { getParticipantFirstLogin } from '../utils/calendarInstrumentUtils'

const mapStateToProps = (state) => {
  const { instruments, loading, strings, user, locales, consent, caregiver } =
    state
  const {
    pendingInstrumentsList,
    instrumentsList,
    allInstrumentsList,
    allInstancesList,
    instancesList,
    futureInstanceList
  } = instruments || {}
  const { selectedLocale } = locales
  const showConsentModal = isBlockConsent(user, consent)
  // When study requires consent and we have pending consents but consent form not yet loaded,
  // keep showing loader so the blocking modal can appear once consentForm (is_blocking) is set (GOLD-11140).
  const pendingConsentsWithoutForm =
    user?.study?.consent_required &&
    (consent?.v2Consents?.length > 0) &&
    !(consent?.consentForm && Object.keys(consent.consentForm).length > 0)
  const loadingOrResolvingConsent = loading.general || pendingConsentsWithoutForm

  return {
    loading: loadingOrResolvingConsent,
    onboarding: user?.onboarding?.instruments,
    pendingInstruments: pendingInstrumentsList || [],
    instruments: instrumentsList || [],
    allInstruments: allInstrumentsList || [],
    allInstances: allInstancesList || [],
    availableInstances: instancesList || [],
    futureInstances: futureInstanceList || [],
    confirmedVisitKeys: instruments?.confirmedVisitKeys || [],
    isInstrumentArch1: !user?.study?.config?.instrument_architecture_version || user?.study?.config?.instrument_architecture_version < 2,
    selectedLocale,
    showConsentModal,
    strings,
    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study,
    studyId: user?.study_id,
    pendingConsents: consent?.v2Consents?.length || 0,
    firstLogin: getParticipantFirstLogin(user),
    participantId: user?.id,
    caregiver,
    user
  }
}

const mapDispatchToProps = {
  fetchInstrument: (url) => onFetchWebSurvey(url),
  sendEvent: (id, eventType, instanceID) =>
    sendEvent(id, eventType, instanceID),
  setSubmissionSurvey: (instrument) => onSetSubmissionSurvey(instrument),
  resetWebSurvey: () => onResetWebSurvey(),
  resetCurrentSurvey: () => onResetCurrentSurvey(),
  resetSubmissionSurvey: () => onResetSubmissionSurvey()
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  if (props.loading) return <Loader />
  return <ActivitiesPage {...props} />
})
